import { ApplicationHttpClient } from "@core/config/application-http-client/application-http-client";
import { ILogin } from "@core/interfaces/login.interface";
import {
  IChangePassword,
  IResetPassword,
} from "@core/interfaces/reset-password.interface";
import { TUserFullInformation } from "@core/types/user-full-information.type";

import { Observable } from "rxjs";

import { Nullable } from "primeng/ts-helpers";

import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class AuthRequest {
  constructor(private httpClient: ApplicationHttpClient) {}

  login(
    email: Nullable<string>,
    password: Nullable<string>,
    token: string,
  ): Observable<ILogin> {
    return this.httpClient.post<ILogin>("/v2/authenticate/login", {
      email,
      password,
      token,
    });
  }

  loginSso(
    userId: string,
    code: string,
    codeVerifier: string,
  ): Observable<ILogin> {
    return this.httpClient.post<ILogin>(`/v2/Authenticate/${userId}/token`, {
      code,
      codeVerifier,
    });
  }

  recoveryAccount(email: string): Observable<void> {
    return this.httpClient.post("/v1/authenticate/change-password-email", {
      email,
    });
  }

  refreshToken(token: string): Observable<ILogin> {
    return this.httpClient.post(
      "/v1/authenticate/refresh-token",
      {},
      { params: new HttpParams().append("refreshTokenId", token) },
    );
  }

  newPassword(password: string): Observable<void> {
    return this.httpClient.post("/v1/authenticate/new-password", {
      password,
      confirmPassword: password,
    });
  }

  changePassword(passwordForm: IChangePassword): Observable<void> {
    return this.httpClient.post("/v1/authenticate/change-password", {
      ...passwordForm,
    });
  }

  changePasswordSsoFirstAccess(password: string): Observable<void> {
    return this.httpClient.post("/v2/authenticate/register-password-sso", {
      password,
      passwordConfirm: password,
    });
  }

  resetPassword(
    passwordForm: IResetPassword,
  ): Observable<TUserFullInformation> {
    return this.httpClient.post("/v1/authenticate/reset-password", {
      ...passwordForm,
    });
  }

  //eslint-disable-next-line
  resendFirstAccessToken(userId: string): Observable<void> {
    return this.httpClient.post(
      `/v1/authenticate/resend-expirated-token/${userId}`,
    );
  }

  verifyToken(userId: string, token: string): Observable<{ valid: boolean }> {
    return this.httpClient.get("/v1/authenticate/verify-token", {
      params: new HttpParams({
        fromObject: {
          userId,
          token,
        },
      }),
    });
  }
}
